import api from '../services/apiService';

const dedupeTeamsById = (teams) => {
    const seen = new Set();
    return teams.filter((team) => {
        const id = String(team?.team_id ?? '');
        if (!id || seen.has(id)) {
            return false;
        }
        seen.add(id);
        return true;
    });
};

export async function fetchYouthOppositionTeams(teamId) {
    const base = process.env.REACT_APP_API_URL;
    const query = teamId ? `&team_id=${teamId}` : '';
    const [academyRes, squadRes] = await Promise.all([
        api.get(`${base}/get_teams.php?type=academy${query}`),
        api.get(`${base}/get_teams.php?type=squad${query}`)
    ]);

    const teams = [
        ...(academyRes.data?.success ? academyRes.data.teams || [] : []),
        ...(squadRes.data?.success ? squadRes.data.teams || [] : [])
    ];

    return dedupeTeamsById(teams).sort((a, b) =>
        (a.team_name || '').localeCompare(b.team_name || '', 'en', { sensitivity: 'base' })
    );
}
